module.exports = __webpack_public_path__ + "static/media/OpenEnded.9cac8e3f.svg";